import { BasicFrame } from 'components/organisms';
import { frameConfigBasicTink } from '../../AppConfig';
import { LightbulbIcon } from 'components/icons';
import { routes } from '../../routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from 'components/atoms/Card/Card';
import classes from 'classnames';
import styles from './TinkBankIssue.module.scss';

export default function TinkBankIssue() {
  const { t } = useTranslation('tinkBankIssue');
  const navigate = useNavigate();

  const onDocCardHandler = () => {
    navigate(
      `${routes.FirstLoan_Manual_Upload}?backRoute=${routes.firstLoan_tink_bank_issue}`,
    );
  };
  const onDocCardRetryHandler = () => {
    navigate(routes.FirstLoan_OnlineBank_Verify);
  };

  const onLaterCardHandler = () => {
    navigate(routes.firstLoan_tink_later);
  };

  return (
    <BasicFrame
      {...frameConfigBasicTink}
      headerLayout="centered"
      onBackBtnHandler={() => navigate(routes.FirstLoan_OnlineBank_Verify)}
    >
      <div className={styles.layout} data-test="tinkBankIssue-layout">
        <div className={styles.title} data-test="tinkBankIssue-title">
          {t('title')}
        </div>
        <Card className={styles['doc-card']} data-test="tinkBankIssue-docCard">
          <div
            className={styles.content}
            data-test="tinkBankIssue-docCard-content"
          >
            {t('docCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankIssue-docButton"
            onClick={onDocCardHandler}
          >
            {t('docCard.ctoDoc')}
          </button>
          <button
            className={classes(styles.button, styles['retry-button'])}
            data-test="tinkBankIssue-retryButton"
            onClick={onDocCardRetryHandler}
          >
            {t('docCard.ctoRetry')}
          </button>
        </Card>
        <Card
          className={styles['later-card']}
          data-test="tinkBankIssue-laterCard"
        >
          <div
            className={styles.heading}
            data-test="tinkBankIssue-laterCard-heading"
          >
            <LightbulbIcon data-test="tinkBankIssue-laterCard-lightbulb" />
            <div
              className={styles.title}
              data-test="tinkBankIssue-laterCard-title"
            >
              {t('laterCard.title')}
            </div>
          </div>
          <div
            className={styles.content}
            data-test="tinkBankIssue-laterCard-content"
          >
            {t('laterCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankIssue-laterCard-button"
            onClick={onLaterCardHandler}
          >
            {t('laterCard.cto')}
          </button>
        </Card>
      </div>
    </BasicFrame>
  );
}
